/**
 * Canonical Plaatsen category list (contract §8 / spec §8.5). Exact copy and
 * order are binding — do not reorder, rename or trim.
 */

export const ALL_CATEGORY = 'Alles'

/** Filter chip list: 'Alles' + 30 place categories. */
export const PLACE_FILTER_CATEGORIES = [
  'Alles',
  'Woonkamer',
  'Slaapkamer',
  'Keuken',
  'Badkamer',
  'Kantoor',
  'Gang',
  'Berging',
  'Auto',
  'Tas',
  'Jas',
  'Broek',
  'Rugzak',
  'Portemonnee',
  'Fiets',
  'Scooter',
  'Schuur',
  'Balkon',
  'Tuin',
  'Toilet',
  'Wasruimte',
  'Meterkast',
  'Nachtkastje',
  'Bureau',
  'Bank',
  'Kast',
  'Lade',
  'Plank',
  'Kapstok',
  'Sleutels',
  'Anders',
] as const

/** Categories selectable in the add/edit form (everything except 'Alles'). */
export const PLACE_CATEGORIES: readonly string[] = PLACE_FILTER_CATEGORIES.filter(
  (category) => category !== ALL_CATEGORY,
)

export const DEFAULT_PLACE_CATEGORY = 'Anders'

/** Category used to prefill the add form from the active filter chip. */
export function prefillCategory(activeFilter: string): string {
  return activeFilter === ALL_CATEGORY ? DEFAULT_PLACE_CATEGORY : activeFilter
}
